
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { IconButton } from "@mui/material";
import React, { Fragment } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {clearCenterNameFunc} from '../../redux-store/actions'


const PaginationContainer = styled.div`
  display: flex;
  z-index:100;
  position: fixed;
  left: 0;
  bottom: 32px;
  width: 13%;
`;

const PaginationArrowBar = ({nextButton, previousButton, page_no, getNoOfCallsRange, totalNumberOfCall}) => {
  const dispatch=useDispatch()
  const {firstNoOfCalls, secondNoOfcalls} =getNoOfCallsRange()
    
 const nextButtonHandler=()=>{

  dispatch(clearCenterNameFunc()) // clearing the center dettails from the redux state
  nextButton()
 }

const previousButtonHandler=()=>{
  dispatch(clearCenterNameFunc())
  previousButton()
}
  return (
    <Fragment>
      <PaginationContainer >
      {page_no >0 &&
        <IconButton disable={!page_no} onClick={previousButtonHandler} style={{ position: "absolute",left:0}}   >
          <KeyboardDoubleArrowLeftIcon style={{fontSize: "25px", color:"black"}}/>
        </IconButton>
      }
      {parseInt(secondNoOfcalls)!== parseInt(totalNumberOfCall) &&

        <IconButton onClick={nextButtonHandler} style={{ position: "absolute",right:0,}}  >
          <KeyboardDoubleArrowRightIcon  style={{fontSize: "25px", color:"black"}}    />
        </IconButton>
      }
      </PaginationContainer>
    </Fragment>
  );
};

export default PaginationArrowBar;
